import { IConfigMapping } from './IConfigMapping';

export const Account: IConfigMapping = {
    signupEnabled: 'account.signupEnabled',
    account_address_default_format: 'account.addresses.defaultFormat',
    account_address_formats: 'account.addresses.permittedAddressFormats'
};
